import { SexuallyTransmittedBloodBorneInfectionScreening } from "./SexuallyTransmittedBloodBorneInfectionScreening";

class PhysicalExam {
    public Particularities: string;
    public Thyroid: string;
    public Neck: string;
    public Heart: string;
    public Lungs: string;
    public Breasts: string;
    public Abdomen: string;
    public LowerLimbs: string;
    public Perineum: string;
    public Vagina: string;
    public Cervix: string;
    public Uterus: string;
    public Adnexa: string;
    public IsCytologyTestsDone: boolean;
    public SexuallyTransmittedBloodBorneInfectionScreening: SexuallyTransmittedBloodBorneInfectionScreening;
    public CorrespondenceBetweenUterineVolumeAndAgeOfPregnancy: string;

    constructor(fields?: Partial<PhysicalExam>) {
        Object.assign(this, fields);
        this.SexuallyTransmittedBloodBorneInfectionScreening = new SexuallyTransmittedBloodBorneInfectionScreening(fields?.SexuallyTransmittedBloodBorneInfectionScreening);
    }
}

export { PhysicalExam };
